// image 转 base64
export async function imageToBase64(imageUrl, callback) {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function() {
      callback(reader.result);
    };
  } catch (err) {
    console.err("imageToBase64", err);
  }
}

// 获取地址中的参数
export function getQueryString(name) {
  const urlParams = new URLSearchParams(location.search);
  return urlParams.get(name);
}
